import stateExtender from '@/store/utils/stateExtender';
import RepositoryFactory from '@/services/repository-factory';
import datatableModule from '@/store/builder/datatableModule';
import table from '@/components/builders/configs/tables/menuGeneralTable';
import filters from '@/components/builders/configs/filters/menuGeneralFilters';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import positionModal from './submodules/positionModal';
import editorDialog from './submodules/editorDialog';

const menuGeneralRepository = RepositoryFactory.get('menuGeneral');
const state = {
  repository: menuGeneralRepository,
  error: null,
};

export default stateExtender({
  namespaced: true,
  state: () => state,
  modules: {
    table: datatableModule({
      fetch: menuGeneralRepository.table,
      headers: table.headers.filter((header) => header.isShown),
      allHeaders: table.headers,
      options: {
        sortBy: ['menuItemId'],
        sortDesc: [true],
        itemsPerPage: 30,
      },
      search: filters,
    }),
    positionModal,
    editorDialog,
  },
  getters,
  mutations,
  actions,
});
